import { useEffect, useRef } from 'react';

export const useResizeEffect = (callback: () => void, timeout: number = 200): void => {
  const resizeTimeoutRef = useRef<number | null>(null);
  const resizeHandlerQueuedRef = useRef<boolean>(false);

  useEffect(() => {
    const handleResize = (): void => {
      if (!resizeHandlerQueuedRef.current) {
        resizeHandlerQueuedRef.current = true;
        window.setTimeout(() => {
          resizeHandlerQueuedRef.current = false;
          callback();
        }, timeout);
      }

      if (resizeTimeoutRef.current) {
        window.clearTimeout(resizeTimeoutRef.current);
      }
      resizeTimeoutRef.current = window.setTimeout(() => {
        callback();
      }, timeout);
    };

    window.addEventListener('resize', handleResize, { passive: true });
    handleResize();

    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  }, [callback, timeout]);
};
